export default {
  state: {
    aimagCities: [],
    relationTypes: []
  },
  mutations: {},
  actions: {
  }
}
